import {NgModule, APP_INITIALIZER} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {HttpClientInMemoryWebApiModule} from 'angular-in-memory-web-api';
import {ClipboardModule} from 'ngx-clipboard';
import {TranslateModule} from '@ngx-translate/core';
import {InlineSVGModule} from 'ng-inline-svg';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CrmRoutingModule} from './crm-routing.module';
import {CrmComponent} from './crm.component';
import {AuthService} from './modules/auth/_services/auth.service';
import {environment} from 'src/environments/environment';
// Highlight JS
import {HighlightModule, HIGHLIGHT_OPTIONS} from 'ngx-highlightjs';
import {SplashScreenModule} from './_metronic/partials/layout/splash-screen/splash-screen.module';
// #fake-start#
import {OffersModule} from './modules/offers/offers.module';
import {FakeAPIService} from './_fake/fake-api.service';
import {TasksModule} from './modules/tasks/tasks.module';
import {TaskViewComponent} from './modules/tasks/task-view/task-view.component';
import {TimeBetweenPipe} from './shared/timeBetween.pipe';
import {ProjectModule} from './modules/projects/project.module';
import {PdpModule} from './modules/pdp/pdp.module';
import {CandidatesModule} from './modules/candidates/candidates.module';
import {ClientsModule} from './modules/clients/clients.module';
import {CustomerSupportModule} from './modules/customer-support/customer-support.module';
import {ContractsModule} from './modules/contracts/contracts.module';
import {TopManagementModule} from './modules/top-management/top-management.module';
import {SharedModuleModule} from '../shared-module/shared-module.module';
import {OcrModule} from './modules/ocr/ocr.module';
import {ReportsModule} from './modules/reports/reports.module';

// #fake-end#

function appInitializer(authService: AuthService) {
    return () => {
        return new Promise((resolve) => {
            authService.getUserByToken().subscribe().add(resolve);
        });
    };
}


@NgModule({
    declarations: [CrmComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SplashScreenModule,
        TranslateModule.forRoot(),
        HttpClientModule,
        HighlightModule,
        ClipboardModule,
        // #fake-start#
        environment.isMockEnabled
            ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
                passThruUnknownUrl: true,
                dataEncapsulation: false,
            })
            : [],
        // #fake-end#
        CrmRoutingModule,
        InlineSVGModule.forRoot(),
        NgbModule,
        ProjectModule,
        OffersModule,
        TopManagementModule,
        ContractsModule,
        TasksModule,
        PdpModule,
        CandidatesModule,
        ClientsModule,
        CustomerSupportModule,
        ContractsModule,
        SharedModuleModule,
        OcrModule,
        ReportsModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializer,
            multi: true,
            deps: [AuthService],
        },
        {
            provide: HIGHLIGHT_OPTIONS,
            useValue: {
                coreLibraryLoader: () => import('highlight.js/lib/core'),
                languages: {
                    xml: () => import('highlight.js/lib/languages/xml'),
                    typescript: () => import('highlight.js/lib/languages/typescript'),
                    scss: () => import('highlight.js/lib/languages/scss'),
                    json: () => import('highlight.js/lib/languages/json')
                },
            },
        },
    ],
    bootstrap: [CrmComponent],
})
export class CrmModule {
}
